const state = {
  listNotifications: [],
  numberNotification: 0,
  totalNotifications: 0
}

export default state
